import Alpine from 'alpinejs'

window.Alpine = Alpine
Alpine.start()

import AOS from 'aos';

var swiper = new Swiper(".mySwiper", {
    effect: "fade",
    loop: true,
    speed: 1500,

    loopedSlides: 1,
    autoplay: {
        delay: 5000,
        disableOnInteraction: false,
    },

    navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
    },
    on: {
        slideChangeTransitionStart: function() {
            $('.textArea').hide(0);
            $('.textArea').removeClass('aos-init').removeClass('aos-animate');

        },
        slideChangeTransitionEnd: function() {
            $('.textArea').show(0);
            AOS.init();
        },
    }
});

AOS.init();

window._ = require('lodash');


/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 */

window.axios = require('axios');

window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

/**
 * Echo exposes an expressive API for subscribing to channels and listening
 * for events that are broadcast by Laravel. Echo and event broadcasting
 * allows your team to easily build robust real-time web applications.
 */

// import Echo from 'laravel-echo';

// window.Pusher = require('pusher-js');

// window.Echo = new Echo({
//     broadcaster: 'pusher',
//     key: process.env.MIX_PUSHER_APP_KEY,
//     cluster: process.env.MIX_PUSHER_APP_CLUSTER,
//     forceTLS: true
// });
